import Vue from 'vue';
import { store } from '@/store/index';
import { Employee } from '@/api';

declare const GLOBAL_TIPS: Record<string, string>;

Vue.prototype.$passwordTips = GLOBAL_TIPS['password'];
Vue.prototype.$isDebug = process.env.NODE_ENV === 'development';
Vue.prototype.$getEmployee = (): Employee | null => {
  return store.state.employee.employee;
};
Vue.prototype.$currentIsExternal = (): boolean => {
  if (store.state.employee.employee?.dingtalk_id) {
    return false;
  }
  return true;
};

declare module 'vue/types/vue' {
  interface Vue {
    $passwordTips: string;
    $isDebug: boolean;
    $getEmployee: () => Employee | null;
    $currentIsExternal: () => boolean;
  }
}
